// export const CONTRACT_ADDRESS = "0xF1466584f9A77081cF8Aebfd68d4759b165F8319"; 


export const CONTRACT_ADDRESS = "0x1aCE190eC3ee8eea3dAA865b5B79aF5510d8c3C0"; 


// New
// 0x71547881e35429ad1e6396BDDcf3e3ef5f35c478
// Older: 
// 0x07C1C1109CCcAF48e40bC190F1626817a95f1072